'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _pathsManifest = require('./pathsManifest');

var _pathsManifest2 = _interopRequireDefault(_pathsManifest);

var _redirectTracker = require('./redirectTracker');

var _redirectTracker2 = _interopRequireDefault(_redirectTracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
*   make user api call on both server and client side to ensure that users are validated and not
*   taking advantage of redux store manipulation
*/

// NOTE: routing seems to be empty using routerReducer from react-router-redux sometimes
// routing.location.search will not process unescaped hashes.
// Example: ?address=123 hello st #345 admiral st will result in
// { routing.location.search: "?123 hello st", routing.location.hash: "#345 admiral st" }
function getRouteParam(routing, param) {
    if (!routing || !routing.location) {
        return '';
    }

    if (param === 'pathname') {
        return routing.location.pathname;
    } else if (param === 'search') {
        return routing.location.search;
    }
}

var AuthCheck = function AuthCheck(_ref) {
    var component = _ref.component,
        _ref$requireStrongAut = _ref.requireStrongAuthentication,
        requireStrongAuthentication = _ref$requireStrongAut === undefined ? false : _ref$requireStrongAut,
        requestAuthFunc = _ref.requestAuthFunc;

    var RenderComponent = function (_React$Component) {
        _inherits(RenderComponent, _React$Component);

        function RenderComponent() {
            _classCallCheck(this, RenderComponent);

            return _possibleConstructorReturn(this, (RenderComponent.__proto__ || Object.getPrototypeOf(RenderComponent)).apply(this, arguments));
        }

        _createClass(RenderComponent, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _props = this.props,
                    brand = _props.brand,
                    routing = _props.routing;

                var toUrl = getRouteParam(routing, 'pathname');
                var otherParams = getRouteParam(routing, 'search');

                // NOTE: requestAuthFunc is expected to be a dispatchable action
                // NOTE: requestAuthFunc is expected to return a response that includes a "loggedIn" value
                // this is prevent content from being displayed in case of redux store manipulation
                this.props.dispatch(requestAuthFunc({
                    pageWithSensitiveInformation: requireStrongAuthentication
                })).then(function () {
                    var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                    var redirectTo = null;

                    if (!response.loggedIn) {
                        /* eslint-disable */
                        redirectTo = '' + _pathsManifest2.default[brand].signInPage(toUrl, otherParams);
                    } else if (requireStrongAuthentication && !response.hasStrongAuthentication && !response.impersonatorUserToken && !response.impersonatorEmail) {
                        /* eslint-disable */
                        redirectTo = '' + _pathsManifest2.default[brand].passwordResetPage(toUrl, otherParams);
                    }

                    var userToken = response.userToken,
                        loggedIn = response.loggedIn,
                        email = response.email,
                        hasStrongAuthentication = response.hasStrongAuthentication;

                    if (redirectTo) {
                        (0, _redirectTracker2.default)({
                            userToken: userToken,
                            loggedIn: loggedIn,
                            email: email,
                            hasStrongAuthentication: hasStrongAuthentication,
                            redirectTo: redirectTo
                        });

                        try {
                            window.stop();
                        } catch (exception) {
                            document.execCommand('Stop');
                        }
                        window.location = redirectTo;
                    }
                });
            }
        }, {
            key: 'render',
            value: function render() {
                var _props2 = this.props,
                    hasStrongAuthentication = _props2.hasStrongAuthentication,
                    loggedIn = _props2.loggedIn;


                if (loggedIn && (requireStrongAuthentication ? hasStrongAuthentication : true)) {
                    return _react2.default.createElement(component, _extends({}, this.props));
                } else {
                    return null;
                }
            }
        }], [{
            key: 'userRequiredBeforeMount',

            // this function requires the server to make a user info api requester before continuing
            value: function userRequiredBeforeMount() {
                return true;
            }
        }, {
            key: 'serverRouteWillMount',
            value: function serverRouteWillMount(reactContext) {
                var _reactContext$store$g = reactContext.store.getState(),
                    user = _reactContext$store$g.user,
                    app = _reactContext$store$g.app,
                    routing = _reactContext$store$g.routing;

                var toUrl = getRouteParam(routing, 'pathname');
                var otherParams = getRouteParam(routing, 'search');

                if (!user.loggedIn) {
                    return {
                        redirect: true,
                        to: '' + _pathsManifest2.default[app.brand].signInPage(toUrl, otherParams),
                        changeHttpStatus: 302
                    };
                } else if (user.loggedIn && requireStrongAuthentication && !user.hasStrongAuthentication) {
                    return {
                        redirect: true,
                        to: '' + _pathsManifest2.default[app.brand].passwordResetPage(toUrl, otherParams),
                        changeHttpStatus: 302
                    };
                } else if (component.serverRouteWillMount) {
                    return component.serverRouteWillMount(reactContext);
                }

                return true;
            }
        }]);

        return RenderComponent;
    }(_react2.default.Component);

    ;

    // we need the store to make serverRouteWillMount work
    // so we might as well pull details from it elsewhere as well
    var mapStateToProps = function mapStateToProps(state) {
        return {
            brand: state.app.brand,
            routing: state.routing,
            loggedIn: state.user.loggedIn,
            hasStrongAuthentication: state.user.hasStrongAuthentication
        };
    };

    return (0, _reactRedux.connect)(mapStateToProps)(RenderComponent);
};

AuthCheck.propTypes = {
    component: _propTypes2.default.object,
    requireStrongAuthentication: _propTypes2.default.bool,
    requestAuthFunc: _propTypes2.default.func.isRequired,
    loggedIn: _propTypes2.default.bool.isRequired,
    brand: _propTypes2.default.bool,
    routing: _propTypes2.default.object.isRequired
};

AuthCheck.defaultProps = {
    brand: 'zillow'
};

exports.default = AuthCheck;